import { render } from "./InputSelect.vue?vue&type=template&id=ec033d94"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"

import "./InputSelect.vue?vue&type=style&index=0&id=ec033d94&lang=scss"
script.render = render

export default script